/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { BettingRecordTrack } from '@store/bettingHistoryStore'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import SharedSuccessImg from '@assets/images/icon/betting_history_icon/success-shared.png'
import SharedFailImg from '@assets/images/icon/betting_history_icon/fail-shared.png'
import SharedCancelImg from '@assets/images/icon/betting_history_icon/cancel-shared.png'
import { Button } from '@styles/button.style'
import { BettingListStyle } from '@views/Popup/Chat/index.style'
import BettingListBg from '@assets/images/bg/shared-betting-history-bg.png'
import * as _ from 'lodash'
import uuid from 'uuid'
import { getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated } from '@utils/jsxutils'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'

interface SimpleBettingHistoryProps {
  bettingRecordTrack?: BettingRecordTrack
  onClickOpenBettingListInfo: (e: React.MouseEvent<HTMLElement>) => void
  className?: string
}

const SimpleBettingHistory: React.FC<SimpleBettingHistoryProps> = (props: SimpleBettingHistoryProps) => {
  const { matchupStore } = useRootStore()
  const { bettingRecordTrack, className = '', onClickOpenBettingListInfo } = props
  const { folds } = bettingRecordTrack

  const hitState = bettingRecordTrack.bet.hitState
  let hitStateClassName = 'state'
  let hitStateImg = <Fragment/>
  let showHitState: boolean
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      hitStateImg = <img src={SharedSuccessImg} alt="적중" className="hit-state-img"/>
      showHitState = true
      break
    case BET_HIT_STATE.FAIL:
      hitStateImg = <img src={SharedFailImg} alt="미적중" className="hit-state-img"/>
      showHitState = true
      break
    case BET_HIT_STATE.CANCEL:
      hitStateImg = <img src={SharedCancelImg} alt="적특" className="hit-state-img"/>
      showHitState = true
      break
    default:
      hitStateClassName += ' adv-hidden'
      showHitState = false
      break
  }

  // TODO folds 값이 들어오지 않고 있음
  const sportIconElements = _.map(getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated(
    _.map(folds, fold => fold.sportId), matchupStore.feedSupplier), element => (
    <span key={uuid.v4()}>
      {element}
    </span>
  ))

  return (
    <Button TP css={BettingListStyle} onClick={onClickOpenBettingListInfo} className={className}>
      <img src={BettingListBg} alt="베팅 내역 공유 이미지" className="betting-list-bg"/>

      {showHitState && (
        <div className={hitStateClassName}>
          {hitStateImg}
        </div>
      )}

      <ul className="betting-list-info">
        <li className="betting-list-info--item">
          <span className="betting-list-info--item--num">{bettingRecordTrack.bet.foldCount}</span>
          <span className="betting-list-info--item--txt">폴드</span>
        </li>
        <li className="betting-list-info--item bottom">
          <div className={isMobile? 'sports-ico-wrap': 'sports-ico-wrap pc'}>
            {sportIconElements}
          </div>
          <div>
            <span className="betting-list-info--item--num rate">
              {Number(bettingRecordTrack.bet.dividendRate).toFixed(2)}
            </span>
            <span className="betting-list-info--item--txt">배당</span>
          </div>
        </li>
      </ul>
    </Button>
  )
}
export default observer(SimpleBettingHistory)
